import { graphql } from '@/generated/gql';

export const DELETE_ABSENCE_MUTATION = graphql(/* GraphQL */ `
  mutation DeleteAbsence($userId: UUID, $id: UUID!) {
    astronaut {
      user(id: $userId) {
        absence {
          delete(data: { id: $id })
        }
      }
    }
  }
`);
